<template>
  <div class="interactiveTutorial"
       v-if="showTutorial"
       :style="{'background-image': returnBackground('assets/img/tutorial-background.jpg')}">
    <div class="interactiveTutorial__hotmap" :style="{top: checkTop, left: checkLeft}" :data-size="checkHotMapSize">
      <div class="interactiveTutorial__hotmap__circle" v-if="isPastNthSlide(0)">
        <div class="interactiveTutorial__hotmap__touchIcon" :style="{top: checkIconTop, left: checkIconLeft}">
          <img :src="returnPath('assets/img/icons/touch.png')" :class="{'is-rotated': rotateMapIcon}" alt=""/>
        </div>
      </div>
    </div>
    <transition name="slideFromRight">
      <div class="interactiveTutorial__closeUp" v-if="isPastNthSlide(0)" :data-active="isCurrentSlide(2)">
        <div class="interactiveTutorial__closeUp__item interactiveTutorial__closeUp__item--view">
          <div class="interactiveTutorial__closeUp__content">
            <div class="icon icon--arrow">
              <svg width="23px" height="41px" viewBox="0 0 23 41" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"
                   transform="translate(-43.000000, -492.000000)">
                  <polygon fill="#FFFFFF" fill-rule="nonzero"
                           points="44.0752276 511.681877 43 512.752078 44.0752276 513.822279 63.3430205 533 64.724332 531.372183 45.2020849 512.236129 45.2020849 513.822279 65.2103456 493.581684 63.8495447 492"></polygon>
                </g>
              </svg>
            </div>
            <span>Product List</span>
          </div>
        </div>
        <div class="interactiveTutorial__closeUp__item interactiveTutorial__closeUp__item--carousel">
          <div class="interactiveTutorial__closeUp__content">
            <div class="icon icon--file">
              <svg width="21px" height="26px" viewBox="0 0 21 26" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <g class="Inspiration-Icon" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"
                   transform="translate(-12.000000, -9.000000)">
                  <g class="Group" transform="translate(13.000000, 10.000000)" stroke="#FFFFFF" stroke-width="1.5">
                    <polyline class="Shape" stroke-linecap="square" points="19 8 12 8 12 1"></polyline>
                    <polygon class="Shape" stroke-linecap="square"
                             points="12.2436925 0.0106856634 0 0 0 24 18.9887207 24 19 6.03739982"></polygon>
                    <polygon class="Path-2" points="4 20 4 12 15 12 15 20"></polygon>
                  </g>
                </g>
              </svg>
            </div>
            <span>Project Inspiration</span>
          </div>
        </div>
        <div class="interactiveTutorial__closeUp__item interactiveTutorial__closeUp__item--grid">
          <div class="interactiveTutorial__closeUp__content">
            <div class="icon icon--grid">
              <svg width="44px" height="44px" viewBox="0 0 44 44" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <g class="Grid-Icon" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g class="Grid_Icon-OFF">
                    <g class="Group" transform="translate(11.000000, 11.000000)" stroke="#FE0000" stroke-width="1.5">
                      <rect class="Rectangle" x="1.19187632" y="0.75" width="20.0581237" height="20.5"></rect>
                      <path d="M6.5,1 L6.5,21" class="Path-2"></path>
                      <path d="M11.5,1 L11.5,21" class="Path-2-Copy"></path>
                      <path d="M16.5,1 L16.5,21" class="Path-2-Copy-2"></path>
                      <g class="Group-2"
                         transform="translate(11.500000, 11.000000) rotate(-270.000000) translate(-11.500000, -11.000000) translate(6.000000, 1.000000)">
                        <path d="M0.5,0 L0.5,20" class="Path-2"></path>
                        <path d="M5.5,0 L5.5,20" class="Path-2-Copy"></path>
                        <path d="M10.5,0 L10.5,20" class="Path-2-Copy-2"></path>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </div>
            <span>Show Grids</span>
          </div>
        </div>
      </div>
    </transition>
    <transition name="slideFromBottom">
      <div class="interactiveTutorial__changeView" v-if="isCurrentSlide(1) || isCurrentSlide(2)">
        <p>Change View</p>
      </div>
    </transition>
    <transition name="SlideFromBottom">
      <div class="interactiveTutorial__viewsList" v-if="isCurrentSlide(2)">
        <div>Change View</div>
        <img :src="returnPath('assets/img/view-list-map.png')" alt=""/>
      </div>
    </transition>
    <transition name="slideUpAway">
      <div class="interactiveTutorial__content" v-show="isContentVisible">
        <div class="interactiveTutorial__carousel">
          <div class="interactiveTutorial__slide" v-for="slide in slides">
            <div class="interactiveTutorial__slide__content">
              <div class="interactiveTutorial__title">{{slide.title}}</div>
              <p>{{slide.description}}</p>
            </div>
          </div>
        </div>
        <div class="interactiveTutorial__nav">
          <div class="interactiveTutorial__bullet" v-for="slide in slides"></div>
        </div>
        <div class="interactiveTutorial__cta">
          <a href="#" class="btn btn--prev"></a>
          <a href="#" class="btn btn--next">{{isLastSlide}}</a>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  var slider;

  export default{
    data(){
      return {
        isContentVisible: true,
        showTutorial: true,
        slides: [],
        hotmap: {
          top: '100%',
          left: '150%',
          icon: {
            top: '100%',
            left: '150%',
          }
        },
        rotateIcon: false,
        activeSlideIndex: 0,
        labels: {
          next: 'Next',
          finish: 'I want to get started!'
        }
      }
    },
    created(){
      var vm = this;
      vm.slides = vm.$store.state.labels.interactiveMode.tutorial;
    },
    computed: {
      rotateMapIcon(){
        return this.rotateIcon;
      },
      checkTop(){
        return this.hotmap.top;
      },
      checkLeft(){
        return this.hotmap.left;
      },
      checkIconTop(){
        return this.hotmap.icon.top;
      },
      checkIconLeft(){
        return this.hotmap.icon.left;
      },
      isLastSlide(){
        var vm = this;
        return vm.$store.state.labels.interactiveMode.tutorial[vm.activeSlideIndex].cta;

      },
      checkHotMapSize(){
        var size;
        switch (this.activeSlideIndex) {
          case 0:
          {
            size = 'default';
            break;
          }
          case 1:
          {
            size = 'default';
            break;
          }
          case 2:
          {
            size = 'small';
            break;
          }
          case 3:
          {
            size = 'big';
            break;
          }
          default:
          {
            size = 'default';
            break;
          }
        }
        return size;
      }
    },
    methods: {
      returnBackground(){
        var bgPath = 'assets/img/unity-' + ENV.currentScene + '-background.jpg';
        return 'url(' + ENV.assetsRoot + bgPath + ')';
      },
      returnPath(path){
        if (ENV.debugMode) {
          return ENV.assetsRoot + path;
        }
        else {
          return ENV.assetsRoot + path;
        }
      },
      initSlider(){

        slider = tns({
          container: '.interactiveTutorial__carousel',
          items: 1,
          slideBy: 1,
          autoplay: false,
          controls: false,
          nav: true,
          navContainer: '.interactiveTutorial__nav',
          loop: false,
          arrowKeys: true,
          speed: 500
        });

        slider.events.on('indexChanged', function () {
          vm.activeSlideIndex = slider.getInfo().index;
          vm.checkActiveSlide();
        });

        var vm = this;

        vm.$nextTick()
          .then(function () {
            var nextBtn = document.querySelector('.btn--next');
            var bullets = document.querySelectorAll('.interactiveTutorial__bullet');

            bullets.forEach(function (elem) {
              elem.addEventListener('click', function (evt) {
                evt.preventDefault();
                vm.activeSlideIndex = parseInt(elem.getAttribute('data-nav'));
                slider.goTo(vm.activeSlideIndex);
                vm.checkActiveSlide();
              })
            });

            nextBtn.addEventListener('click', function (evt) {
              evt.preventDefault();
              if (vm.activeSlideIndex == (bullets.length - 1)) {
                vm.isContentVisible = false;
                vm.setCookie();
                vm.$store.state.hasTutorialPlayed = true;
                setTimeout(function () {
                  vm.$emit('hide-tutorial');
                }, 1000);
                return;
              }
              if (vm.activeSlideIndex < bullets.length) {
                vm.activeSlideIndex++;
                slider.goTo(vm.activeSlideIndex);
                vm.checkActiveSlide();
              }
            });
          });
      },
      isPastNthSlide(n){
        if (this.activeSlideIndex > n) {
          return true;
        }
      },
      isCurrentSlide(n){
        if (this.activeSlideIndex == n) {
          return true;
        }
      },
      setCookie(){
        var date = new Date();
        date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000));
        document.cookie = 'iguzzini-dle=iguzzini-dle-tutorial; ; expires=' + date.toUTCString();
      },
      setHotMapPosition(x, y){
        this.hotmap.left = x;
        this.hotmap.top = y;
      },
      setHotMapIconPosition(x, y){
        this.hotmap.icon.left = x;
        this.hotmap.icon.top = y;
      },
      checkActiveSlide(){
        switch (this.activeSlideIndex) {
          case 0:
          {
            this.setHotMapPosition('50%', '50%');
            this.setHotMapIconPosition('50%', '60%');
            this.rotateIcon = false;
            break;
          }
          // case 1:
          // {
          //   this.setHotMapPosition('50%', '20%');
          //   this.setHotMapIconPosition('50%', '60%');
          //   this.rotateIcon = false;
          //   break;
          // }
          // case 2:
          case 1:
          {
            this.setHotMapPosition('95.5vw', '130px');
            this.setHotMapIconPosition('-10%', '50%');
            this.rotateIcon = true;
            break;
          }
          // case 3:
          case 2:
          {
            this.setHotMapPosition('8.5%', '83%');
            this.setHotMapIconPosition('40%', '60%');
            this.rotateIcon = false;
            break;
          }
          default:
          {
            this.setHotMapPosition('150%', '50%');
            this.setHotMapIconPosition('65%', '60%');
            this.rotateIcon = false;
            break;
          }
        }
      }
    },
    mounted(){
      var vm = this;
      vm.slides = vm.$store.state.labels.interactiveMode.tutorial;
      this.$nextTick()
        .then(function () {
          vm.initSlider();
        })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/InteractiveTutorial.vue